import createIcon from '../../createIcon';

/**
 * @component @name FormatPaint
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSA0VjNDMTcuNSAyLjQ1IDE3LjA1IDIgMTYuNSAySDQuNUMzLjk1IDIgMy41IDIuNDUgMy41IDNWN0MzLjUgNy41NSAzLjk1IDggNC41IDhIMTYuNUMxNy4wNSA4IDE3LjUgNy41NSAxNy41IDdWNkgxOC41VjEwSDguNVYyMUM4LjUgMjEuNTUgOC45NSAyMiA5LjUgMjJIMTEuNUMxMi4wNSAyMiAxMi41IDIxLjU1IDEyLjUgMjFWMTJIMjAuNVY0SDE3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatPaint = createIcon('FormatPaint', [
  [
    'path',
    {
      d: 'M17.5 4V3C17.5 2.45 17.05 2 16.5 2H4.5C3.95 2 3.5 2.45 3.5 3V7C3.5 7.55 3.95 8 4.5 8H16.5C17.05 8 17.5 7.55 17.5 7V6H18.5V10H8.5V21C8.5 21.55 8.95 22 9.5 22H11.5C12.05 22 12.5 21.55 12.5 21V12H20.5V4H17.5Z',
      key: '1a0mi9',
    },
  ],
]);

export default FormatPaint;
